import React from "react";
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

export interface DotMeterProps {
  size: number;
  filled: number;
  title: string;
}

export const DotMeter = ({
  size,
  filled,
  title
}: DotMeterProps): JSX.Element => {
  return (
    <Tooltip title={title} placement="top" enterDelay={0}>
      <DotMeterWrapper
        role="meter"
        aria-valuemin={0}
        aria-valuemax={size}
        aria-valuenow={filled}
        aria-valuetext={`stage ${filled}`}
      >
        {/* We need to create as many dots as the size given, we can use the index to figure out which are filled*/}
        {Array.from(Array(size)).map((_, index) => (
          <Dot key={index} filled={filled > index} />
        ))}
      </DotMeterWrapper>
    </Tooltip>
  );
};

const DotMeterWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;

const Dot = styled("span")<{ filled: boolean }>`
  height: 20px;
  width: 20px;
  border: black solid 1px;
  background-color: ${props =>
    props.filled ? props.theme.palette.primary.main : "#bbb"};
  border-radius: 50%;
  display: inline-block;
`;
